import { alpha } from '@mui/material';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

const rotate = keyframes(`to { transform: rotate(1turn); }`);

export const useSpinnerStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    width: '1em',
    aspectRatio: '1',
    borderRadius: '50%',
    border: `0.1em solid ${alpha(theme.palette.primary.main, 0.2)}`,
    borderRightColor: theme.palette.primary.main,
    animation: `${rotate} 1s infinite linear`,
  },
}));
